import {getBrandingFromUrl} from '@hconnect/common/branding/Branding.utils'
import {useBreakPoints} from '@hconnect/uikit'
import {InputMessage} from '@hconnect/uikit/src/lib2'
import {InfoOutlined} from '@mui/icons-material'
import {Box, Button, Card, Typography} from '@mui/material'
import clsx from 'clsx'
import {useTranslation} from 'react-i18next'

import {LinkToSignIn} from '../../../../Components/AccountForm/LinkToSignIn'
import {StepForm} from '../../../../Components/SelfOnBoarding/StepForm'
import {useGlobalState} from '../../../../hooks/useGlobalState'
import {DEContactUsUrl, UKContactUsUrl} from '../../RequestAccessSelfOnboarding.types'
import {useRafStyles} from '../../styles'

import {useStyles} from './RegistrationStep.styles'

import {ReactComponent as RegistrationCustomerNumber} from '@hconnect/authenticator/src/Assets/raf_registration_customer_number.svg'
import {ReactComponent as RegistrationInvoice} from '@hconnect/authenticator/src/Assets/raf_registration_invoice.svg'
import {ReactComponent as RegistrationInvoiceUK} from '@hconnect/authenticator/src/Assets/raf_registration_invoice_uk.svg'

export const RegistrationStep = () => {
  const screenSizes = useBreakPoints()
  const isMobile = ['xs'].includes(screenSizes)
  const {t} = useTranslation()
  const {classes} = useStyles()
  const {classes: generalClasses} = useRafStyles()
  const {globalState} = useGlobalState()
  const branding = getBrandingFromUrl(globalState.redirectUrl)

  const handleContactUsLink = () => {
    if (branding === null || branding.country === 'DE') {
      window.open(DEContactUsUrl, '_blank', 'noopener,noreferrer')
    } else if (branding.country === 'GB') {
      window.open(UKContactUsUrl, '_blank', 'noopener,noreferrer')
    } else if (branding.contactEmail) {
      const subject = t(
        'authenticator.requestAccessSelfOnboarding.registrationStep.contactUsSubject'
      )
      window.location.href = `mailto:${encodeURIComponent(
        branding.contactEmail
      )}?subject=${encodeURIComponent(subject)}`
    }
  }

  return (
    <Box style={{display: 'flex', flexDirection: 'column'}}>
      <Typography className={generalClasses.title}>
        {t('authenticator.requestAccessSelfOnboarding.registrationStep.title')}
      </Typography>
      <Typography
        className={generalClasses.description}
        style={{
          marginTop: '16px'
        }}
      >
        {t('authenticator.requestAccessSelfOnboarding.registrationStep.subtitle')}
      </Typography>
      <Box
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '16px',
          marginTop: '32px',
          marginBottom: '10px'
        }}
      >
        <Card className={classes.infoCard}>
          <RegistrationCustomerNumber />
          <Typography className={classes.infoText}>
            {t('authenticator.requestAccessSelfOnboarding.registrationStep.customerNumberInfo')}
          </Typography>
        </Card>
        <Card className={classes.infoCard}>
          {branding.country === 'GB' ? <RegistrationInvoiceUK /> : <RegistrationInvoice />}
          <Typography className={classes.infoText}>
            {t('authenticator.requestAccessSelfOnboarding.registrationStep.invoiceInfo')}
          </Typography>
        </Card>
      </Box>
      <InputMessage
        variant="info"
        startIcon={<InfoOutlined style={{fontSize: '24px'}} />}
        message={t(
          'authenticator.requestAccessSelfOnboarding.registrationStep.contactUsDescription'
        )}
        actionItem={
          <Button
            className={clsx(generalClasses.secondaryButton, generalClasses.contactUsButton)}
            onClick={handleContactUsLink}
            data-test-id="contact-us-button"
          >
            {t('authenticator.requestAccessSelfOnboarding.registrationStep.contactUsTitle')}
          </Button>
        }
      />
      <StepForm
        submitText={t(
          'authenticator.requestAccessSelfOnboarding.registrationStep.startRegistration'
        )}
        data-test-id="start-registration-btn"
        className={clsx(generalClasses.primaryButton, generalClasses.confirmButton)}
      />
      <Box style={{placeSelf: 'center'}}>
        <LinkToSignIn />
      </Box>
    </Box>
  )
}
